import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import PhaserActionButton from './PhaserActionButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HearingIcon from '@mui/icons-material/Hearing';
import CalculateIcon from '@mui/icons-material/Functions';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import AnimationIcon from '@mui/icons-material/Animation';
import TaskScene from '../../PhaserApp/components/application/scene/TaskScene';
import { CalculationTask } from '../../PhaserApp/components/application/tasks/CalculationTask';
import { StroopTask } from '../../PhaserApp/components/application/tasks/StroopTask';
import { ReactionTask } from '../../PhaserApp/components/application/tasks/ReactionTask';
import { PhaserActionButtonStyle } from './PhaserActionButtonGroupStyle';

export interface PhaserActionButtonGroupProps {
  phaserRef: React.MutableRefObject<Phaser.Game | null>;
  isVisual: boolean;
  isAudio: boolean;
  isCalculation: boolean;
  isStroop: boolean;
  isShape: boolean;
}

const PhaserActionButtonGroup: React.FC<PhaserActionButtonGroupProps> = ({
  phaserRef,
  isVisual,
  isAudio,
  isCalculation,
  isStroop,
  isShape,
}) => {
  const { buttonContainer } = PhaserActionButtonStyle;
  const leftGroupRotation = -45;
  const rightGroupRotation = 45;
  const calcReaction = () => {
    const scene = phaserRef.current?.scene.keys.therapist as TaskScene;
    if (scene) {
      const calcTask = scene.composite.GetTask(CalculationTask) as CalculationTask;
      if (calcTask) {
        calcTask.handleCalculationButtonPress();
      } else {
        console.warn('CalculationTask not found in composite.');
      }
    } else {
      console.warn('Phaser scene not available yet.');
    }
  };

  const stroopReaction = () => {
    const scene = phaserRef.current?.scene.keys.therapist as TaskScene;
    if (scene) {
      const stropTask = scene.composite.GetTask(StroopTask) as StroopTask;
      if (stropTask) {
        stropTask.handleStroopButtonPress();
      }
    }
  };

  const auditoryReaction = () => {
    const scene = phaserRef.current?.scene.keys.therapist as TaskScene;
    if (scene) {
      const auditory = scene.composite.GetTask(ReactionTask) as ReactionTask;
      if (auditory) {
        auditory.handleAuditoryButtonPress();
      }
    }
  };

  const visualReaction = () => {
    const scene = phaserRef.current?.scene.keys.therapist as TaskScene;
    if (scene) {
      const visual = scene.composite.GetTask(ReactionTask) as ReactionTask;
      if (visual) {
        visual.handleVisualButtonPress();
      }
    }
  };

  const animation = () => {
    const scene = phaserRef.current?.scene.keys.therapist as TaskScene;
    if (scene) {
      const animation = scene.composite.GetTask(ReactionTask) as ReactionTask;
      if (animation) {
        animation.handleAnimationButtonPress();
      }
    }
  };

  return (
    <Box sx={buttonContainer}>
      <PhaserActionButton
        className={`visual finger-button ${isVisual ? 'active-finger' : ''}`}
        onClick={visualReaction}
        icon={<VisibilityIcon fontSize={'large'} />}
        backgroundColor="#80CBC4"
        rotateDeg={leftGroupRotation}
        isRightGroup={false}
        isDisabled={!isVisual}
      />
      <PhaserActionButton
        className={`audio finger-button left ${isAudio ? 'active-finger' : ''}`}
        onClick={auditoryReaction}
        icon={<HearingIcon fontSize={'large'} />}
        backgroundColor="#A5C9E8"
        rotateDeg={leftGroupRotation}
        isRightGroup={false}
        width={480}
        isDisabled={!isAudio}
      />
      <PhaserActionButton
        className={`calculation finger-button ${isCalculation ? 'active-finger' : ''}`}
        onClick={calcReaction}
        icon={<CalculateIcon fontSize={'medium'} />}
        backgroundColor="#E89DA5"
        rotateDeg={rightGroupRotation}
        isDisabled={!isCalculation}
      />
      <PhaserActionButton
        className={`stroop finger-button ${isStroop ? 'active-finger' : ''}`}
        onClick={stroopReaction}
        icon={<PsychologyAltIcon fontSize={'medium'} />}
        backgroundColor="#C1B7EA"
        rotateDeg={rightGroupRotation}
        width={480}
        isDisabled={!isStroop}
      />
      <PhaserActionButton
        className={`animation finger-button ${isShape ? 'active-finger' : ''}`}
        onClick={animation}
        icon={<AnimationIcon />}
        backgroundColor="#F2D7A0"
        rotateDeg={rightGroupRotation}
        width={520}
        isDisabled={!isShape}
      />
    </Box>
  );
};

export default PhaserActionButtonGroup;
